import React from "react";
import Image from "next/image";

export default function MiniLogo({ size }) {
  return (
    <>
    <Image
        alt=""
        src="/images/logo2.png"
        layout="fixed"
        width="155"
        height="22"
        priority={true}
      />
    </>
  )
}